import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import {SkyLightStateless} from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Data, CheckboxEditor } from 'react-data-grid-addons';
import _ from 'lodash';
import { Field } from 'redux-form';
import { Grid, Button, ButtonToolbar, Row, Col, Panel } from 'react-bootstrap';
import { Selection } from '../Common/selection';
import { InputField } from '../Common/inputField';
import { Translate, Localize } from 'react-redux-i18n';
import PurchasePivotChartSearchProd from '../../containers/Purchase/purchasePivotChartSearchProd';

import { ROOT_URL } from '../../actions/root_url';

const IsVariableFormatter = React.createClass({
    render() {
      return <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                style={{ height: '23px', width: '39px', padding: '0px' }}
                onClick={ () => { this.props.deletePurchaseLine(this.props.dependentValues.Product_id) } }
              >
                  <Translate value="X" />
              </Button>
            </span>;
    }
});

const EffectNowFormatter = React.createClass({
  render() {
    return (
      <input type="checkbox" value="true" checked={this.props.value == true || this.props.value == "true"} onClick={()=>{this.props.handleEffectNowClick(this.props)}}/>
    )
  }
})

class PurchasePivotChartDetail extends Component {
  static contextTypes = {
      router: React.PropTypes.object
  };
  constructor() {
    super();

    this.state = {
      purchase: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        columns: [
          {
              key: 'Delete',
              name: <Translate value="delete" />,
              formatter: <IsVariableFormatter deletePurchaseLine={this.deletePurchaseLine.bind(this)}/>,
              width: 50,
              getRowMetaData: (row) => row
          },
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 90,
          },
          {
              key: 'Name',
              name: <Translate value="prod_name" />,
              resizable: true,
              sortable: true,
              width: 100,
          },
        ]
      },
      quote: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        columns: [
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 90,
          },
        ]
      },
      isToday: true,
      vendors: [],
      addRowsOpen: false,
      curVendor: null,
    }
    // this.deleteLine = this.deleteLine.bind(this);
    this.closeAddRows = this.closeAddRows.bind(this);
    this.openAddRows = this.openAddRows.bind(this);
    this.addCols = this.addCols.bind(this);
    this.selectProduct = this.selectProduct.bind(this);
    this.handleCellSelected = this.handleCellSelected.bind(this);
    this.generateQuote = this.generateQuote.bind(this);
    this.handleEffectNowClick = this.handleEffectNowClick.bind(this);
  }

  componentWillMount() {
      this.props.fetchVendors();
      this.props.resetCurrentPurchaseQuote();
      if(this.props.purchasePivot_id)
        this.props.fetchPurchasePivotChartsDetail(this.props.purchasePivot_id)
  }

  componentWillUnmount() {
    this.props.resetPurchasePivotCharts();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.purchasePivotChartsDetail && nextProps.purchasePivotChartsDetail != this.props.purchasePivotChartsDetail) {
      let date = new Date(nextProps.purchasePivotChartsDetail.PostingDate);
      let today = new Date();
      date = this.changeDateFormat(date);
      today = this.changeDateFormat(today);
      let isToday = true;
      if(date < today) {
        isToday = false;
      }

      let columns = [...this.state.purchase.columns];
      let vendors = nextProps.purchasePivotChartsDetail.Vendors;
      let rows = [...nextProps.purchasePivotChartsDetail.Purchase_Pivot_Line];
      vendors.map(vendor => {
        columns = columns.concat(
          [
            {
                key: `${vendor}_Quantity`,
                name: <Translate value={`${vendor}_qty`} />,
                resizable: true,
                editable: true,
                sortable: true,
                width: 80,
            },
            {
                key: `${vendor}_FOBUnitPrice`,
                name: <Translate value={`${vendor}_$$`} />,
                resizable: true,
                editable: true,
                sortable: true,
                width: 80,
            },
            {
                key: `${vendor}_IsCheck`,
                name: <Translate value={`${vendor}_enable`} />,
                resizable: true,
                editable: true,
                sortable: true,
                width: 80,
                formatter: <EffectNowFormatter Col={`${vendor}_IsCheck`} handleEffectNowClick={this.handleEffectNowClick}/>,
                getRowMetaData: (row) => row
            },
          ]
        );
        rows.map(row => {
          let index = _.findIndex(row.Purchase_Pivot_Company_line, {VendorNum: vendor});
          if(index > -1) {
            row[`${vendor}_Quantity`] = row.Purchase_Pivot_Company_line[index].Quantity;
            row[`${vendor}_FOBUnitPrice`] = row.Purchase_Pivot_Company_line[index].FOBUnitPrice;
            row[`${vendor}_IsCheck`] = row.Purchase_Pivot_Company_line[index].IsCheck;
            row[`${vendor}_OrderQuantity`] = row.Purchase_Pivot_Company_line[index].OrderQuantity;
          }
        })
      })
      let purchase = {...this.state.purchase, rows: rows, columns: columns}
      this.setState({purchase, vendors, isToday});
    }
  }

  handleFormSubmit(formProps) {
    this.props.createPurchasePivotChart(formProps, this.state.vendors, Data.Selectors.getRows(this.state.purchase))
  }

  generateQuote() {
    this.props.createPurchaseQuote({ VendorNum: this.state.curVendor }, this.state.quote.rows);
  }

  closeAddRows() {
    this.setState({addRowsOpen: false})
  }

  openAddRows() {
    this.setState({addRowsOpen: true})
  }

  addCols(vendor) {
      let vendors = [...this.state.vendors];
      if(vendors.indexOf(vendor) > -1) {
        return;
      }
      vendors.push(vendor);
      let columns = [...this.state.purchase.columns];
      columns = columns.concat(
        [
          {
              key: `${vendor}_Quantity`,
              name: <Translate value={`${vendor}_qty`} />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 80,
          },
          {
              key: `${vendor}_FOBUnitPrice`,
              name: <Translate value={`${vendor}_$$`} />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 80,
          },
          {
              key: `${vendor}_IsCheck`,
              name: <Translate value={`${vendor}_enable`} />,
              resizable: true,
              editable: true,
              sortable: true,
              width: 80,
              formatter: <EffectNowFormatter Col={`${vendor}_IsCheck`} handleEffectNowClick={this.handleEffectNowClick}/>,
              getRowMetaData: (row) => row
          },
        ]
      );
      let purchase = {...this.state.purchase, columns: columns}
      this.setState({purchase, vendors})
  }

  addRows() {
    let purchase = {...this.state.purchase}
    this.setState({purchase})
  }

  // deleteLine(WarehouseReceiveLine_id) {
  //   let quote = {...this.state.quote};
  //   quote.rows.map(r => {
  //     if(r.WarehouseReceiveLine_id == WarehouseReceiveLine_id) {
  //       r.show = false;
  //     }
  //   })
  //   this.setState({quote});
  // }

  deletePurchaseLine(Product_id) {
    let purchase = {...this.state.purchase};
    purchase.rows = purchase.rows.filter(r => {
      return r.Product_id != Product_id;
    })
    this.setState({purchase});
  }

  handleEffectNowClick(isCheck) {
    let purchase = {...this.state.purchase};
    let col = isCheck.Col;
    purchase.rows[isCheck.dependentValues.Idx][col] = !(purchase.rows[isCheck.dependentValues.Idx][col]);
    this.setState({purchase});
  }

  getVendorNumOptions() {
      let vendorNumOptions = [];
      this.props.vendors.map(vendor => {
          vendorNumOptions.push({ value: vendor.VendorNum, label: vendor.VendorNum })
      });
      return vendorNumOptions;
  }

  changeDateFormat(day) {
    let y = day.getFullYear().toString();
    let m = day.getMonth()+1;
    if(m < 10) {
      m = '0'+m;
    }
    else {
      m = m.toString();
    }
    let d = day.getDate();
    if(d < 10) {
      d = '0'+d;
    }
    else {
      d = d.toString();
    }
    d = y + m + d;
    return d;
  }

  selectProduct(prod) {
    let purchase = {...this.state.purchase}
    let index = _.findIndex(purchase.rows, {ProductNum: prod.ProductNum})
    if(index == -1) {
      purchase.rows.push(prod);
      this.setState({purchase});
    }
  }

  handleCellSelected(coordinates) {
    let idx = parseInt(coordinates.idx/3);
    if(idx) {
      idx = idx * 3 + 2;
    }
    let cols = [...this.state.purchase.columns];
    let key = cols[idx].key
    let rows = [...this.state.purchase.rows]
    let quoteRows = [];
    rows.map(row => {
      if(row[key] === "true" || row[key] === true) {
        quoteRows.push(row);
      }
    })
    let l = key.length - 8;
    let vendor = key.slice(0, key.length - 8);
    let columns = [
      {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 90,
      },
      {
          key: `${vendor}_FOBUnitPrice`,
          name: <Translate value="unit_price" />,
          width: 50,
      },
      {
          key: `${vendor}_OrderQuantity`,
          name: <Translate value="qty" />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 50,
      },
      {
          key: `${vendor}_IsCheck`,
          name: <Translate value={`${vendor}`} />,
          resizable: true,
          editable: true,
          sortable: true,
          width: 100,
          formatter: <EffectNowFormatter Col={`${vendor}_IsCheck`} handleEffectNowClick={this.handleEffectNowClick}/>,
          getRowMetaData: (row) => row
      },
    ]
    let quote = {...this.state.quote, rows: quoteRows, columns: columns};
    this.setState({quote, curVendor: vendor});
  }

  renderPurchaseTable() {
    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return (
      <div id="spinner">
        <Spinner/>
      </div>
    )
    else if (this.props.purchasingPerformanceError) return (
     <ContentWrapper>
       <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
     </ContentWrapper>
    )
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.purchase);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return Object.assign({Idx: rowIdx}, rows[rowIdx]);
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var purchase = Object.assign({}, this.state.purchase, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({purchase});
        }

        const handleRowUpdated = e => {
          let rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
        }

        //React Table Purchase Order Full Table
        return (
          <Row>
            <Col sm={ 12 }>
              <div style={{ maxWidth: '100%' }} id="PurchasePivotChartDetail-dataGrid1">
                <ReactDataGrid
                    enableCellSelect={true}
                    onCellSelected={this.handleCellSelected}
                    onGridSort={handleGridSort}
                    columns={this.state.purchase.columns}
                    rowHeight={25}
                    minHeight={630}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    onRowUpdated={handleRowUpdated}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }

  renderPrintTable() {
    // const deleteLine = this.deleteLine;
    // if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return (
    //   <div id="spinner">
    //     <Spinner/>
    //   </div>
    // )
    // else if (this.props.purchasingPerformanceError) return (
    //  <ContentWrapper>
    //    <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
    //  </ContentWrapper>
    // )
    // else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.quote);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var quote = Object.assign({}, this.state.quote, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({quote});
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const handleRowUpdated = e => {
          let rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
        }

        // Column difinition

        return (
          <Row>
            <Col sm={ 12 }>
              <div className="react-table-price-adjustment-print" id="PurchasePivotChartDetail-dataGrid2">
                <ReactDataGrid
                    enableCellSelect={true}
                    onRowUpdated={handleRowUpdated}
                    onGridSort={handleGridSort}
                    columns={this.state.quote.columns}
                    rowHeight={25}
                    minHeight={630}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                  />
              </div>
            </Col>
          </Row>
        )
    // }
  }

  render() {
    const { handleSubmit } = this.props;
    let print_url = null;
    let excel_url = null;
    if(this.props.purchasePivotChartsDetail) {
      print_url = ROOT_URL + 'v1/purchase/pivotexport/print/' + this.props.purchasePivotChartsDetail.PurchasePivot_id + "?Bearer=" + localStorage.getItem('token');
      excel_url = ROOT_URL + 'v1/purchase/pivotexport/excel/' + this.props.purchasePivotChartsDetail.PurchasePivot_id + "?Bearer=" + localStorage.getItem('token');
    }
    let vendorNumOptions = this.getVendorNumOptions();
    let date = this.props.purchasePivotChartsDetail && this.props.purchasePivotChartsDetail.PostingDate;
    if(date)
      date = new Date(date);
    else
      date = new Date();
    date = this.changeDateFormat(date);
    date = date && `${date.slice(4, 6)} / ${date.slice(6)} / ${date.slice(0, 4)}`;
    let createDialogStyle = {
        height: '600px',
        width: '600px',
        marginLeft: '-10%',
    };
    return (
      <ContentWrapper>
        <Grid fluid="true" id="purchase-pivot-chart-detail">
          <form autoComplete="off" method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
            <h1><Translate value="quote_reference_chart_detail" /> {date}</h1>
            <ButtonToolbar>
              <Button bsStyle="danger" onClick={()=>{ this.context.router.push('/purchasePivotChart')}}>
                <em className="fa fa-close"/>
              </Button>
              <Button bsStyle="primary" href={print_url}>
                <Translate value="print" />
              </Button>
              <Button bsStyle="primary" href={excel_url}>
                <Translate value="excel" />
              </Button>
              <Button bsStyle="success" type="submit" disabled={!(this.state.isToday)}>
                <Translate value="save" />
              </Button>
              {this.props.purchaseQuoteCreated && <div className="generate-quote alert alert-success"><span><Translate value="msg_purchase_quote_generated" /></span></div>}
              {this.props.purchaseQuoteIsCreating && <div className="generate-quote"><Spinner/></div>}
            </ButtonToolbar>
            <Row>
              <Col md={ 9 }>
                <Panel className="purchase-panel">
                <Row>
                  <div className="col-md-12 vendor">
                    <Row>
                      <Col md={ 12 }>
                        <Col md= { 7 }>
                          <label className="col-md-2"><Translate value="name" /><span className="asteriksReq">*</span></label>
                          <Col md={3}><Field name="Name" component={InputField}/></Col>
                          <label className="col-md-offset-1 col-md-2"><Translate value="description" /></label>
                          <Col md={3}><Field name="Description" component={InputField}/></Col>
                        </Col>
                        <Col md={ 5 }>
                          <div className="col-md-8"><Field name="Vendor" component={Selection} options={vendorNumOptions}/></div>
                          <Button className="pull-right" bsStyle="primary" onClick={()=>{this.addCols(this.props.vendor.value)}}>
                            <Translate value="add_vendor" />
                          </Button>
                        </Col>
                      </Col>
                    </Row>
                  </div>
                </Row>
                <Row>
                  <Col sm={ 12 }>
                    {this.renderPurchaseTable()}
                  </Col>
                </Row>
                <br/>
                <Row>
                  <Col sm={ 12 }>
                    <Button onClick={this.openAddRows}><Translate value="add_product" /></Button>
                  </Col>
                </Row>
              </Panel>
              </Col>
              <Col md={ 3 }>
                <Panel className="quote-panel">
                  <div className="vendor">
                    {this.state.curVendor && <span className="alert alert-warning" id="vendor-span">{this.state.curVendor}</span>}
                    <Button className="pull-right" bsStyle="primary" onClick={()=>{ this.generateQuote()}}>
                      <Translate value="generate_quote" />
                    </Button>
                  </div>
                  {this.renderPrintTable()}
                </Panel>
              </Col>
            </Row>
            <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.addRowsOpen} onCloseClicked={() => { this.closeAddRows() }} title="Choose Product">
              <PurchasePivotChartSearchProd selectProduct={this.selectProduct}/>
            </SkyLightStateless>
          </form>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default PurchasePivotChartDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePivotChartDetail.jsx